<template>
  <div>
    <vs-popup class="user-edit-popup"
              id="popup"
              title="UPDATE FORECAST"
              @close="open = false"
              :active.sync="open"
              :buttons-hidden="true">
      <vx-card no-shadow >
        <ValidationObserver ref="form" v-slot="{ handleSubmit }">
          <form autocomplete="off">
            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <ValidationProvider vid="customers" name="customers" rules="required"
                                    v-slot="{ errors }">
                  <span v-if="customer_data.customer_type === 'customer'">
                    <small class="label">Customer</small>
                    <vs-input readonly class="w-full" name="value" type="text" v-model="customer_data.data.company_name"/>
                  </span>
                  <span  v-if="customer_data.customer_type === 'lead'">
                    <small class="label">Lead</small>
                    <vs-input readonly class="w-full" name="value" type="text" v-model="customer_data.data.code"/>
                  </span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <ValidationProvider vid="time_interval" name="time_interval" rules="required"
                                    v-slot="{ errors }">
                  <small class="label">Time Interval</small>
                  <vs-input readonly class="w-full" name="time_interval" type="text" value="Monthly"/>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <ValidationProvider vid="unit" name="unit" rules="required"
                                    v-slot="{ errors }">
                  <small class="label">Unit</small>
                  <vs-input readonly class="w-full" name="unit" type="text" value="Kg"/>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3" v-for="(tool, index_tool) in forecast_tools" :key="index_tool">
              <div class="vx-col w-full" v-if="is_table_visible">
                <vx-card :card-border="true" :collapseAction="true" :title="`${tool.new ? 'NEW' : (tool.formulation_code || 'TBC')}`"
                  :remove-card-action="true" v-on:remove="onRemoveNewTool(tool.id, index_tool)">
                  <div class="vx-row mb-3">
                    <div class="vx-col md:w-1/3 w-full md:mb-0">
                      <ValidationProvider vid="formulations" name="formulations"
                                          v-slot="{ errors }">
                        <small class="label mb-2">Finished Product</small>
                        <vs-input v-if="!tool.new && !!tool.formulation_code" readonly class="w-full" name="value" type="text" v-model="tool.formulation_code"/>
                      <v-select v-if="tool.new || !tool.formulation_code" :clearable="false" name="formulations" placeholder="" label="formulation_code"
                                v-model="tool.formulation_id"
                                :options="formulations"
                                :reduce="option => option.id"
                                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      />
                        <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
                        <span class="mt-0 text-xs text-danger" v-if="isProductAlreadyUsed(tool.formulation_id) && tool.new">This product is alredy used in this forecast.</span>
                      </ValidationProvider>
                    </div>
                    <div class="vx-col md:w-1/3 w-full md:mb-0">

                      <small class="label mb-2">Financial Year</small>
                      <v-select :clearable="false" name="financial_year" placeholder="" label="value"
                                v-model="financial_year[index_tool]"
                                :options="f_y_arr"
                                :reduce="option => option.key"
                                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      />

                    </div>
                    <div class="vx-col md:w-1/3 w-full md:mb-0 mt-4">
                      <vs-button v-if="tool.items.filter((item )=> item.financial_year.toString() === financial_year[index_tool] ).length <= 1" color="success"
                                 class="ml-auto mt-3" @click="addInitialItems(index_tool)" :disabled="isProductAlreadyUsed(tool.formulation_id)">
                        <small>Create Forecast Tool</small>
                      </vs-button>
                      <span v-if="!tool.new">
                        <small class="label mb-2">Enter a static monthly amount?</small>
                        <vs-switch @input="onChangeStaticAmount(forecast_tools[index_tool].static_monthly_amount, index_tool)" v-model="forecast_tools[index_tool].static_monthly_amount"></vs-switch>
                      </span>
                    </div>
                  </div>
                  <div class="vx-row mb-3" v-if="forecast_tools[index_tool].static_monthly_amount" >
                    <div class="vx-col md:w-1/3 w-full md:mb-0">
                      <small class="label mb-2">Static Value (Kg)</small>
                      <vs-input class="w-full" name="value" type="text" v-model="tool.static_value"/>
                    </div>
                    <div class="vx-col md:w-1/3 w-full md:mb-0">
                      <small class="label mb-2">Static Amount (GBP)</small>
                      <vs-input class="w-full" name="value" type="text" v-model="tool.static_amount"/>
                    </div>
                    <div class="vx-col md:w-1/3 w-full md:mb-0">
                      <vs-button color="success" class="ml-auto mt-3" @click="addStaticMonthlyValues(index_tool, tool.static_value, tool.static_amount)" >
                        <small>Save</small>
                      </vs-button>
                    </div>
                  </div>
                  <div class="vx-row">
                    <div class="vx-col w-full">
                      <vx-card subtitle="Items" :id="`forecast_tool_card_${index_tool}`">
                        <table class="full-page-bg-color" border="0">
                          <thead>
                          <tr>
                            <th width="35%" class="head text-center">Period (Monthly)</th>
                            <th width="35%" class="head text-center">Value (Kg)</th>
                            <th width="30%" class="head text-center">Amount (GBP)</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr class="vs-con-loading__container" style="cursor: pointer; z-index: 100" :key="index_item" :id="`item_${index_tool}_${index_item}`"
                              v-for="(item, index_item) in tool.items.filter((item )=> item.financial_year.toString() === financial_year[index_tool] )">
                            <td>
                              <ValidationProvider :vid="`${index_tool}${index_item}date`" :name="`${index_tool}${index_item}date`"
                                                  v-slot="{ errors }" rules="required">
                                <flat-pickr disabled class="w-full" :config="flatPkrConfig" v-model="item.date" placeholder="Choose Date" />
                                <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
                              </ValidationProvider>
                            </td>
                            <td>
                              <ValidationProvider :vid="`${index_tool}${index_item}value`" :name="`${index_tool}${index_item}value`" rules="required"
                                                  v-slot="{ errors }">
                                <vs-input class="w-full" name="value" type="text" v-model="item.value" :id="`value_${index_tool}_${index_item}`"
                                          @keyup.enter="enterValue(index_tool, index_item)" @keyup.down="enterValue(index_tool, index_item)"
                                          :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                              </ValidationProvider>
                            </td>
                            <!-- @change="updateValue(index_tool,index_item)" -->
                            <td>
                              <ValidationProvider :vid="`${index_tool}${index_item}amount`" :name="`${index_tool}${index_item}amount`" rules="required"
                                                  v-slot="{ errors }">
                                <vs-input class="w-full" name="amount" type="text" v-model="item.amount"
                                          :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                              </ValidationProvider>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                        <div class="vx-row" v-if="!tool.new">
                          <div class="vx-col w-full">
                            <vs-button @click.stop="onClickUpdateForeCast(index_tool)" class="float-right mt-4 mr-2">Save</vs-button>
                          </div>
                        </div>
                      </vx-card>
                    </div>
                  </div>
                </vx-card>
              </div>
            </div>

            <div class="flex flex-wrap items-center justify-end mt-8">
              <vs-button class="ml-auto mt-2" @click="addNewProduct">Add New Product</vs-button>
            </div>

          </form>
        </ValidationObserver>
      </vx-card>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import {RepositoryFactory} from "@/repository/RepositoryFactory";
import SuccessMessage from "@/mixins/SuccessMessage";
import ErrorMessages from '@/mixins/ErrorMessages'
import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css'
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect/index.js'
import 'flatpickr/dist/plugins/monthSelect/style.css'
import moment from "moment/moment";

const ForecastRepository = RepositoryFactory.get('forecast')
const FormulationsRepository = RepositoryFactory.get('formulations')
const CustomerRepository = RepositoryFactory.get('customer')
const SettingsRepository = RepositoryFactory.get('settings');

function initialState() {
  return {
    open: false,
    time_interval: null,
    unit: null,
    formulation_code: null,
    customer_name: null,
    items: [],
    formulations: [],
    customers: [],
    forecastId:null,
    customer_data: {
      company_name: '',
      code: '',
      id: ''
    },
    forecast_tools: [],
    forecast_configs: {
      config_time_interval: 'month',
    },
    financial_year: [
      moment().year() + ''
    ],
    f_y_arr: [
      { key: '2022', value: '2022/2023' },
      { key: '2023', value: '2023/2024' },
      { key: '2024', value: '2024/2025' },
      { key: '2025', value: '2025/2026' },
    ],
    is_table_visible: true,
    is_contain_tbc: false
  }
}

export default {
  name: "UpdateForecast",
  data() {
    return initialState()
  },
  mixins: [SuccessMessage, ErrorMessages],
  components: {
    flatPickr,
    'v-select': vSelect,
  },
  methods: {
    async openPopup(customer_data) {
      await Object.assign(this.$data, initialState());
      this.$refs.form.reset()
      this.items = []
      this.customer_data = customer_data
      await this.fetchSettings()
      await this.fetchForecast()
      await this.fetchFormulations()
      this.open = true
    },
    async fetchFormulations() {
      this.$vs.loading();
      this.formulations = []
      const { data } = await FormulationsRepository.getListOfFormulationNoPagination(0)
      this.formulations = data.data
      if(!this.is_contain_tbc) {
        this.formulations.unshift({ id: null, formulation_code: 'TBC' })
      }
      this.$vs.loading.close()
    },
    async fetchForecast(){
      this.$vs.loading();
      const { data } = (await ForecastRepository.getForecastList(`${this.customer_data.customer_type === 'customer' ? 'customer_id' : 'customer_lead_id'}=${this.customer_data.data.id}`)).data
      if(data.length === 0){
        await this.createForecast()
      }else {
        this.forecast_tools = data[0].forecast_tools
        this.forecast_tools.map((tool, index) => {
          this.financial_year[index] = tool.items[0].financial_year.toString()
          tool.static_monthly_amount = false
        })
        this.is_contain_tbc = this.forecast_tools.some((x) => !x.formulation_id)

      }
      this.$vs.loading.close()
    },

    async createForecast() {
      await this.addNewProduct()
    },
    async addInitialItems(index = 0)
    {
      if(this.forecast_tools[index].formulation_id === ""){
          this.showErrorMessage("Select the finished product!")
      } else {
          await this.setFirstDate(index, this.forecast_tools[index].items.length)
          const rounds = this.forecast_configs.config_time_interval === 'week' ? 52 : 12
          for (let i = 1; i < rounds; i++) {
            this.addNewItem(index)
          }
          await this.onClickUpdateForeCast(index)
      }
    },

    addNewItem(index, value = 0, amount = 0){
      const items_length = this.forecast_tools[index].items.length
      let nextDate = ''
      if(items_length >= 1){
        const date = this.forecast_tools[index].items[items_length - 1].date
        nextDate = moment(date,'DD/MM/YYYY').add(1,  this.forecast_configs.config_time_interval).format('DD/MM/YYYY')
      }
      this.forecast_tools[index].items.push({ date: nextDate, value: value , amount: parseFloat(amount).toFixed(2) , financial_year: this.financial_year[index] })
    },

    async setFirstDate(tool_index = 0, item_index = 0){
      this.forecast_tools[tool_index].items.push({
            date: '',
            value: '',
            amount: '',
            financial_year:''
      })
      this.forecast_tools[tool_index].items[item_index].date = `01/${moment(this.financial_year_start_month, 'MMMM').format('MM')}/${this.financial_year[tool_index]}`
      this.forecast_tools[tool_index].items[item_index].value = 0
      this.forecast_tools[tool_index].items[item_index].amount = parseFloat(0).toFixed(2)
      this.forecast_tools[tool_index].items[item_index].financial_year = this.financial_year[tool_index];
    },

    async addNewProduct() {
      this.forecast_tools.push(
        {
          new:true,
          formulation_id: '',
          items: []
        }
      )
      this.financial_year[this.forecast_tools.length - 1] = moment().year() + ''
    },
    updateValue(index_tool,index_item){
      this.updateItemValue(this,index_tool,index_item)
    },
    enterValue(index_tool, index_item) {
      if(this.forecast_tools[index_tool].items.length - 1 > index_item) {
        document.getElementById(`value_${index_tool}_${index_item + 1}`).focus();
        document.getElementById(`value_${index_tool}_${index_item + 1}`).select();
      }
    },
    updateItemValue: _.debounce((vm,tool_index,index_item) => {
      vm.onClickUpdateForeCast(tool_index,index_item)
    },50),

    async fetchSettings() {
      this.$vs.loading();
      this.financial_year_start_month = (await SettingsRepository.getTheItem('financial_year_start_month')).data.data.financial_year_start_month;
      this.forecast_tool_time_interval = (await SettingsRepository.getTheItem('sales_marketing_tool_time_interval')).data.data.sales_marketing_tool_time_interval;
      if(this.forecast_tool_time_interval && this.forecast_tool_time_interval !== ''){
        if(this.forecast_tool_time_interval === 'monthly'){
          this.forecast_configs.config_time_interval = 'months'
        }
        if(this.forecast_tool_time_interval === 'weekly') {
          this.forecast_configs.config_time_interval = 'week'
        }
        if(this.forecast_tool_time_interval === 'daily') {
          this.forecast_configs.config_time_interval = 'day'
        }
      }
      this.$vs.loading.close()
    },

    removeCard(index) {
      this.items.splice(index, 1)
    },
    async onRemoveNewTool(id, index) {
      if(!id) {
        this.forecast_tools.splice(index, 1)
      } else {
        await ForecastRepository.deleteForecast(id)
        await this.fetchForecast()
        await this.fetchFormulations()
        await this.$emit('refreshData')
      }
    },
    onClickRemoveItem(index_tool, index_item) {
      this.forecast_tools[index_tool].items.splice(index_item, 1)
    },
    checkDate(item_index){
      let validation = ''
      this.items.map((item, index) => {
        if (index !== item_index) {
          if (this.items[index].date === this.items[item_index].date) {
            validation = `unique_date:${this.items[index].date}`
          }
        }
      })
      return validation;
    },
    async onClickUpdateForeCast(index, index_item = 0) {
      const vue = this
      this.$refs.form.reset();
      const validated = await this.$refs.form.validate().then((x) =>{
        return x
      })
      if(validated) {
        if(this.forecast_tools[index].new){
          await this.$vs.loading()
          try {
            let payload = {}
            if(this.customer_data.customer_type === 'customer') {
              payload = {
                customer_id: this.customer_data.data.id,
                forecast_tools: this.forecast_tools.filter((tool) => tool.new && tool.new === true)
              }
            }
            if(this.customer_data.customer_type === 'lead') {
              payload = {
                customer_lead_id: this.customer_data.data.id,
                forecast_tools: this.forecast_tools.filter((tool) => tool.new && tool.new === true)
              }
            }
            
            await ForecastRepository.createForecast(payload)
            this.showSuccessMessage('Forecast tool created successfully');
            await this.fetchForecast()
            await this.fetchFormulations()
            await vue.$emit('refreshData')
          }catch (error){

            this.forecast_tools[index].items = []
            // this.showErrorMessage('Selected product has already been taken in this forecast!', 5000)
            this.convertAndNotifyError(error)
          }
          this.$vs.loading.close()
        }else {
          // await this.$vs.loading({
          //   container: index_item ? `#item_${index}_${index_item}`: `#forecast_tool_card_${index}`,
          //   scale: 0.45
          // })
          await this.$vs.loading()
          try {
            const vue = this
            const payload = {
              formulation_id: this.forecast_tools[index].formulation_id,
              items: this.forecast_tools[index].items.map((x) => ({
                date: x.date,
                value: x.value,
                amount: parseFloat(x.amount).toFixed(2),
                financial_year: x.financial_year
              }))
            }
            await ForecastRepository.updateForecast(this.forecast_tools[index].id, payload)
            await this.fetchForecast()
            await this.fetchFormulations()
          } catch (error) {
            // this.$vs.loading.close(index_item ?`#item_${index}_${index_item} > .con-vs-loading`:  `#forecast_tool_card_${index} > .con-vs-loading`)
            this.convertAndNotifyError(error)
          }
          await this.$vs.loading.close()
        }
        // this.$vs.loading.close(index_item ?`#item_${index}_${index_item} > .con-vs-loading`:  `#forecast_tool_card_${index} > .con-vs-loading`)
      }
    },
    isProductAlreadyUsed(formulation_id) {
      return !!this.forecast_tools.filter((x) => !x.new).find((x) => x.formulation_id === formulation_id)
    },
    onChangeStaticAmount(value, index) {
      this.is_table_visible = !this.is_table_visible
      this.is_table_visible = !this.is_table_visible
    },
    async addStaticMonthlyValues(index_tool, value, amount) {
      this.forecast_tools[index_tool].items = this.forecast_tools[index_tool].items
        // .filter((item )=> item.financial_year.toString() === this.financial_year[index_tool] )
        .map((item) => {
          item.value = value
          item.amount = amount
          return item
        })
      await this.onClickUpdateForeCast(index_tool)
      this.forecast_tools[index_tool].static_monthly_amount = false
      this.forecast_tools[index_tool].static_amount = 0
      this.forecast_tools[index_tool].static_value = 0
    }
  },
  computed:{
    flatPkrConfig(){
      const interval = this.time_interval
      return {
        dateFormat: 'd/m/Y',
        plugins: [
          new monthSelectPlugin({
            shorthand: true,
            dateFormat: "d/m/Y",
          })
        ],
        enable: [
          function (date) {
            if (interval === 'monthly') {
              return (date.getDate() === 1)
            }
            if (interval === 'weekly') {
              return (date.getDay() === 1)
            }
            return true
          }
        ]
      };
    },
  },
}
</script>

<style scoped>
.user-edit-popup >>> .vs-popup {
  width: 40%;
}

table {
  border-collapse: collapse;
  width: 100%;
}

td, th {
  text-align: left;
  padding: 8px;
}
</style>
